module.exports = __webpack_public_path__ + "assets/img/Nexon-5-Landing-Page.d767e035.webp";